var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-avatar"},[_c('md-avatar',[(_vm.user.avatar_url)?_c('img',{attrs:{"src":_vm.user.avatar_url,"alt":""}}):_c('md-icon',[_vm._v("\n      person\n    ")])],1),_vm._v(" "),(!_vm.noName)?_c('span',[_vm._v("\n    "+_vm._s(_vm.user.forename ? `${_vm.user.forename} ${_vm.user.surname}` : _vm.user.name)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }